import { observer } from 'mobx-react-lite';
import {
    labelNoLongerApply,
    labelIncorrect,
    justificationOther,
    justificationModalHeader,
    justificationModalSubtext,
    justificationConfirmButtonText,
    justificationCancelButtonText,
} from './CLPDowngradeModal.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';
import { Dialog, DialogType, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import { PrimaryButton, DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { OwaModalProps } from 'owa-modal/lib/showModal';
import { ChoiceGroup } from 'office-ui-fabric-react/lib/ChoiceGroup';
import { TextField } from 'office-ui-fabric-react/lib/TextField';

type CLPModalResult = {
    success: boolean;
    downgradeJustification: string;
};

export default observer(function CLPDowngradeModal(props: OwaModalProps<CLPModalResult>) {
    const isPresetJustification = React.useRef<boolean>(true);
    const [downgradeJustification, setDowngradeJustification] = React.useState<string>('');
    const confirmDialog = (): void => {
        props.onDismiss({
            success: true,
            downgradeJustification: downgradeJustification,
        });
    };
    const closeDialog = (): void => {
        props.onDismiss({
            success: false,
            downgradeJustification: null,
        });
    };
    const onChoiceChange = (ev: React.FormEvent<HTMLInputElement>, option: any): void => {
        if (option.key != 'OTHERS') {
            setDowngradeJustification(option.value || '');
            isPresetJustification.current = true;
            return;
        }
        isPresetJustification.current = false;
    };
    const onTextFieldChange = (ev: React.FormEvent<HTMLInputElement>, newValue?: string) => {
        if (!isPresetJustification.current) {
            setDowngradeJustification(newValue || '');
        }
    };
    const justificationOptions = [
        {
            key: 'LABEL_NOT_APPLY',
            text: loc(labelNoLongerApply),
            value: 'Previous label no longer applies',
        },
        {
            key: 'LABEL_NOT_CORRECT',
            text: loc(labelIncorrect),
            value: 'Previous label was incorrect',
        },
        {
            key: 'OTHERS',
            text: loc(justificationOther),
            onRenderField: (props, render) => {
                return (
                    <div>
                        {render(props)}
                        {props.checked && (
                            <TextField multiline={true} rows={3} onChange={onTextFieldChange} />
                        )}
                    </div>
                );
            },
            styles: {
                choiceFieldWrapper: {
                    width: '100%',
                },
                field: {
                    marginBottom: '10px',
                },
            },
        },
    ];
    const disabled = downgradeJustification ? false : true;
    return (
        <Dialog
            hidden={false}
            onDismiss={closeDialog}
            dialogContentProps={{
                type: DialogType.normal,
                title: loc(justificationModalHeader),
                subText: loc(justificationModalSubtext),
            }}>
            <ChoiceGroup options={justificationOptions} onChange={onChoiceChange} />

            <DialogFooter>
                <PrimaryButton
                    onClick={confirmDialog}
                    disabled={disabled}
                    text={loc(justificationConfirmButtonText)}
                />
                <DefaultButton onClick={closeDialog} text={loc(justificationCancelButtonText)} />
            </DialogFooter>
        </Dialog>
    );
});
